/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0; you may not use this file except in compliance with the Elastic License
 * 2.0.
 */

// DO NOT MODIFY THIS FILE BY HAND. IT IS GENERATED BY
// `yarn workspace @elastic/esql-definitions generate` FROM
// `elasticsearch/promql/x-pack-esql/definition/operators/label_re.json`.

import type { PromqlOperatorDefinition } from '../../definition_types';

/**
 * Matches labels whose value satisfies the provided regular expression.
 *
 * @example
 * requests_total{method=~"GET|POST"}
 */
const definition: PromqlOperatorDefinition = {
  type: 'label_matching_operator',
  operator: '=~',
  name: 'label_re',
  signatures: [
    {
      params: [
        {
          name: 'label',
          type: 'string',
          optional: false,
          description: 'Label name.',
        },
        {
          name: 'value',
          type: 'string',
          optional: false,
          description: 'String or regex.',
        },
      ],
      variadic: false,
      returnType: 'instant_vector',
    },
  ],
  snapshotOnly: false,
};

export default definition;
